import { Site } from "../resources/modelTypes";
import { SiteProvider } from "./models/SiteContext";
import React, { memo, ReactNode } from "react";

type ModelContextsProps = {
  children: ReactNode;
  initialSites: Site[];
};

const ModelContextsComponent = ({
  children,
  initialSites,
}: ModelContextsProps) => (
  <SiteProvider initialItems={initialSites}>{children}</SiteProvider>
);

export const ModelContexts = memo(ModelContextsComponent);
